import { Editor } from '@tinymce/tinymce-react'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponents/SDNotification'
import { useTranslation } from 'react-i18next'
import { DatePicker } from 'baseui/datepicker'
import { SIZE } from 'baseui/input'
import useFormationForm from './useFormationForm'

const FormationForm = () => {
  const { t } = useTranslation()
  const {
    speedFormation,
    editorRef,
    date,
    setDate,
    setIsEditing,
    saveSpeedFormation,
    isLoading,
    error,
    errorMessage,
    tinymceKey,
  } = useFormationForm()

  return (
    <>
      <Editor
        id='speed-formation-text-input'
        apiKey={tinymceKey}
        initialValue={speedFormation.text}
        onInit={(evt, editor) => (editorRef.current = editor)}
        init={{
          height: 250,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'code',
            'wordcount',
          ],
          toolbar:
            'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
        }}
      />
      <DatePicker
        size={SIZE.compact}
        formatString='dd/MM/yyyy'
        minDate={new Date()}
        maxDate={null}
        value={date ? new Date(date) : new Date()}
        onChange={({ date }) => {
          const dateFormatted = Array.isArray(date) ? new Date(date[0] + ' UTC') : new Date(date ? date + ' UTC' : date)
          setDate(dateFormatted.toISOString())
        }}
      />
      <SDButton id='speed-formation-cancel-button' onClick={() => setIsEditing(false)}>
        {t('common:cancel')}
      </SDButton>
      <SDButton id='speed-formation-save-button' onClick={saveSpeedFormation} isLoading={isLoading}>
        {t('common:save')}
      </SDButton>
      {error && errorMessage && <SDNotification type={'warning'}>{errorMessage}</SDNotification>}
    </>
  )
}

export default FormationForm
